import {
  useGetCurrentUserQuery,
  useGetUserSettingsQuery,
} from '@carboncopyco/data';
import { PinkHandWithBlueLetterIllustration } from '@carboncopyco/illustrations';
import type { Role } from '@carboncopyco/types';
import { PageHeader, PageLayout, Separator, Spacer } from '@carboncopyco/ui';
import { useParams } from 'react-router-dom';
import { ActivitySummaryReport } from './ActivitySummaryReport';
import { EmailNotifications } from './EmailNotifications';

export const NotificationsSettings = () => {
  const { data: userData } = useGetCurrentUserQuery();
  const { organizationId } = useParams();
  const userRole: Role =
    organizationId && userData?.user?.roles?.[organizationId];
  const { data: notificationsSettings } = useGetUserSettingsQuery({
    organizationId,
  });

  return (
    notificationsSettings && (
      <PageLayout
        overflowHidden
        page
        header={
          <PageHeader
            title="Notifications"
            subTitle="Set your email update prefrences"
          />
        }
      >
        {(userRole === 'admin' || userRole === 'owner') && (
          <>
            <Spacer amount={3.75} />
            <ActivitySummaryReport />
            <Spacer amount={3.75} />
            <Separator horizontal />
          </>
        )}
        <Spacer amount={3.75} />
        <div className="flex justify-between">
          <div className="w-4/5">
            <EmailNotifications />
            <Spacer amount={3.75} />
            <Separator horizontal />
            <Spacer amount={3.75} />
          </div>
          <div className="w-1/5">
            <div className="absolute right-0">
              <PinkHandWithBlueLetterIllustration />
            </div>
          </div>
        </div>
      </PageLayout>
    )
  );
};
